<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <el-form
            ref="form"
            :model="form"
            class="demo-ruleForm"
            label-width="120px"
            label-position="left"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="name"
                  label="套餐来源："
                  prop="name"
                  v-if="form.id ? false : true"
                >纸质套餐</el-form-item>
                <el-form-item
                  class="el-form-item-update"
                  ref="name"
                  label="套餐来源："
                  prop="name"
                  v-else
                >
                  <el-input v-model="form.cardOldTypeCn" readonly="" placeholder="请输入套餐类型" maxlength="15"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="name"
                  label="套餐名称："
                  prop="name"
                  :rules="$rules.required"
                >
                  <el-input v-model="form.name" :disabled="disabled" placeholder="请输入套餐名称" maxlength="15"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="salePrice"
                  label="售价："
                  prop="salePrice"
                  :rules="$rules.money"
                >
                  <el-input v-model="form.salePrice" placeholder="请输入售价" maxlength="8"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="achievementAmount"
                  label="划卡业绩："
                  prop="achievementAmount"
                  :rules="$rules.money"
                >
                  <el-input v-model="form.achievementAmount" placeholder="请输入划卡业绩" maxlength="8"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="deductAmount"
                  label="提成金额："
                  prop="deductAmount"
                  :rules="$rules.money"
                >
                  <el-input v-model="form.deductAmount" placeholder="请输入提成金额" maxlength="8"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="paperIndex-info">
              <div class="mb10">温馨提示</div>
              <div>套餐类型：例如 688套餐，888套餐等。保存后套餐类型不可修改</div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns pr16 pb10">
            <el-button @click="back">取消</el-button>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "",
      addEditShow: false,
      form: {},
      columns: [],
      disabled: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.$refs["form"].resetFields();
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        if (org) {
          this.addEditTitle = "编辑纸质套餐";
          this.disabled = true;
          this.$api.get(this.$url.cardOld.gets, {
              id: org.id
            }).then(res => {
              if (res) {
                this.form = res;
              }
            })
        } else {
          this.addEditTitle = "新增纸质套餐";
        }
        this.addEditShow = true;
      });
    },
    handleChangeDrawer() {
      this.$refs["form"].clearValidate();
      this.addEditShow = false;
      this.$emit("change", false);
    },
    onSubmit() {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
            this.$api.post(this.$url.cardOld.saves, this.form).then(res => {
              if (res) {
                this.addEditShow = false;
                this.$refs["form"].clearValidate();
                this.$emit("change", true);
              }
            })
        }
      })
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
  .paperIndex-info {
    position: absolute;
    margin: 0 16px;
    font-size: 16px;
    // width: calc(100%);
    bottom: 60px;
    background: #FBFBFC;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
    color: #666;
    font-weight: 700;
    padding: 20px;
  }
}
</style>